import { memo, useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { FaUpload } from "react-icons/fa";
import Loader from "react-js-loader";
import { ToastContainer, toast } from "react-toastify";
import { getEndpointUrl } from "../../Utils/Common";

const ModalUnggahFoto = ({ onCallback, param, show, close }) => {
  const [uploading, setUploading] = useState(false);

  const [userLogin] = useState(
    JSON.parse(localStorage.getItem("knowLogin")) || [],
  );

  const [accesToken] = useState(
    JSON.parse(localStorage.getItem("credentials")) || [],
  );

  useEffect(() => {}, [uploading, param]);

  const handleFileUpload = async (files, endpoint, fileField, uploadType) => {
    if (!files || files.length === 0) return;

    setUploading(true);

    const BATCH_SIZE = 5; // jumlah file per request

    try {
      const fileArray = Array.from(files);

      // Bagi file menjadi batch agar tidak terlalu besar dalam satu request
      for (let i = 0; i < fileArray.length; i += BATCH_SIZE) {
        const batch = fileArray.slice(i, i + BATCH_SIZE);

        const formData = new FormData();
        batch.forEach((file) => {
          formData.append(fileField + "[]", file);
        });
        formData.append("offer_id", param);

        const response = await fetch(
          getEndpointUrl() + "/v2" + endpoint + "/" + param,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${accesToken}`,
            },
            body: formData,
          },
        );

        const result = await response.json();

        if (
          response.ok &&
          (result.status === "success" || result.status === "ok")
        ) {
          // batch berhasil diupload
          toast.success("Yay, Foto berhasil diupload.", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
          });
          close();  
        } else {
          // batch gagal
          toast.error(result.message, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
          });
        }
      }

      if (typeof onCallback === "function") {
        onCallback();
      }
    } catch (error) {
      toast.error("Terjadi kesalahan: " + error.message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    } finally {
      setUploading(false);
    }
  };
  return (
    <>
      <ToastContainer position="top-end" className="p-3"></ToastContainer>
      <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Unggah Foto Inspeksi</Modal.Title>
        </Modal.Header>
        {uploading ? (
          <Modal.Body>
            <div className="d-flex justify-content-center mt-5 mb-5">
              <Loader type="bubble-scale" bgColor={"#E57373"} size={100} />
            </div>
          </Modal.Body>
        ) : (
          <>
            <Modal.Body>
              <Form.Group>
                <Form.Label for="formFile" className="form-label">
                  Pilih Foto
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) =>
                    handleFileUpload(
                      e.target.files,
                      "/inspector/upload",
                      "foto",
                      "foto",
                    )
                  }
                  disabled={uploading}
                />
                {uploading && (
                  <div className="mt-2">
                    <Spinner size="sm" /> Mengupload...
                  </div>
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={close}>
                {" "}
                Batal{" "}
              </Button>
              <Button variant={"primary"} disabled={uploading}>
                <FaUpload className="me-2" /> Unggah Foto
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default memo(ModalUnggahFoto);
